import React from 'react'

// [claude] Map-app twin of app/javascript/utility/hooks.js (subset). Only
// useIsActive is needed here (Header/Text/icons nav-active state); the server
// session hooks are irrelevant in the CRA map bundle. Keep signatures in sync.

/**
 *
 * @param {string[]} activePaths
 * @returns
 */
export const useIsActive = (activePaths = []) => {
	const { pathname } = window.location
	const isActive = React.useMemo(() => activePaths.map(path => new RegExp(path).test(pathname)).includes(true), [activePaths, pathname])
	return isActive
}
